import { MAX_FULL_NAME_LENGTH } from '@/constants/Common'
import {
  BIRTHDATE_MIN,
  BIRTHDATE_REQUIRED,
  EMAIL_CONFIRM,
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  FULLNAME_NO_SPECIAL,
  FULLNAME_REQUIRED,
  FULL_NAME_MAX_LENGTH,
  TYPE_DATE,
} from '@/constants/MessageConstants'
import moment from 'moment'
import * as Yup from 'yup'
import { LocationValidationSchema } from './CommonValidationSchema'

const ExternalSignUpValidationSchema = Yup.object().shape({
  fullName: Yup.string()
    .required(FULLNAME_REQUIRED)
    .matches(/^[A-Za-z ]+$/, FULLNAME_NO_SPECIAL)
    .max(MAX_FULL_NAME_LENGTH, FULL_NAME_MAX_LENGTH),
  birthDate: Yup.date()
    .typeError(TYPE_DATE)
    .required(BIRTHDATE_REQUIRED)
    .test('is-valid-date', 'Invalid date format', (value) => {
      return moment(value, 'YYYY-MM-DD', true).isValid()
    })
    .test('birthDate', BIRTHDATE_MIN, (value) => {
      return moment().diff(moment(value), 'years') >= 2
    }),
  email: Yup.string()
    .required(EMAIL_REQUIRED)
    .email(EMAIL_INVALID)
    .matches(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\\.]+$/, EMAIL_INVALID),
  confirmEmail: Yup.string()
    .required(EMAIL_REQUIRED)
    .email(EMAIL_INVALID)
    .oneOf([Yup.ref('email'), ''], EMAIL_CONFIRM),
  location: LocationValidationSchema,
})

export default ExternalSignUpValidationSchema
